import { SponsorStudy } from './sponsor-study';
import { CategoryNaturalKey } from '../documents';
import { Params } from '@angular/router';

export class StudyCard {
    public study: SponsorStudy;
    public sponsorItems: CardItem[];
    public studyItems: CardItem[];
}

export class CardItem {
    public name: string;
    public counter: number;
    public link: any[];
    public categoryId?: CategoryNaturalKey;
    public queryParams?: Params;
    public isDisabled: boolean;
    public tooltip?: string;
}